// AuthContext.js
import { createContext, useContext, useEffect } from 'react';

import socketIOClient from 'socket.io-client';
import { toast } from 'react-toastify';
import { useIssues } from './IssueContext';
import { useAuth } from './AuthContext';
import { baseOrigin } from 'api';
import { useState } from 'react';
import { useCallback } from 'react';

const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
  const { user } = useAuth();
  const { updateIssue } = useIssues();

  useEffect(() => {
    // console.log('user changed', user);
  }, [user]);

  const [socket, setSocket] = useState(null);

  useEffect(() => {
    if (!user) return;
    let socketOptions = {};
    if (process.env.REACT_APP_NODE_ENV === 'development') {
      socketOptions = { transports: ['websocket'] };
    }

    const socketObject = socketIOClient(baseOrigin, socketOptions); // Replace with your server URL

    socketObject.once('connect', function () {
      console.log(`Hurrah Socket ${socketObject.id} Connected`);
      const socketId = socketObject.id;

      setSocket(socketObject);

      socketObject.on('updateIssue', function (data) {
        console.log('updateIssueEvent', data);

        updateIssue(data.issue, true);
      });

      socketObject.on('disconnect', function () {
        setSocket(null);
        console.log(`Socket ${socketId} Disconnected`);
      });
    });

    // Clean up the socket connection when the component unmounts
    return () => socketObject.disconnect();
  }, [user]);

  return <SocketContext.Provider value={{}}>{children}</SocketContext.Provider>;
};

export const useSocket = () => useContext(SocketContext);
